<template>
  <div>
    manual create
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>